const baseApi = '/api/v1/admin/paymenttypesegment';

async function getSegments({ condition }) {
  try {
    const res = await window.window.axios.get(baseApi + '/all', { params: condition });
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function addSegment(data) {
  try {
    const res = await window.window.axios.post(baseApi, data);
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function editSegment(data) {
  try {
    const res = await window.window.axios.put(baseApi, data);
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function deleteSegment(id) {
  try {
    const res = await window.window.axios.delete(baseApi, { params: { id } });
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function getSegment(id) {
  try {
    const res = await window.window.axios.get(baseApi + ``, { params: { id } });
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

module.exports = {
  getSegments,
  addSegment,
  editSegment,
  deleteSegment,
  getSegment,
};
